var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteButtonMin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 137,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfcfc",
    d: "M-.5-.5h98v137h-98V-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#040404",
    d: "M33.5 16.5c7.34-.166 14.674 0 22 .5.916.374 1.75.874 2.5 1.5.498 2.982.665 5.982.5 9 7.008-.166 14.008 0 21 .5 3.463 2.15 4.796 5.316 4 9.5h-77c-.686-3.787.314-6.954 3-9.5 6.992-.5 13.992-.666 21-.5-.556-4.166.444-7.832 3-11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M54.5 21.5v5h-19v-5a45.626 45.626 0 0 1 19 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b4b4b4",
    d: "M35.5 21.5v5h19v-5c.961 1.765 1.295 3.765 1 6h-21c-.295-2.235.039-4.235 1-6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#050505",
    d: "M14.5 44.5h61c.167 24.669 0 49.336-.5 74-.833 2.167-2.333 3.667-4.5 4.5a675.912 675.912 0 0 1-52 0c-1.833-.5-3-1.667-3.5-3.5a2812.97 2812.97 0 0 1-.5-75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b0b0b0",
    d: "M27.5 52.5v62h3c-1.068.934-2.401 1.268-4 1a992.81 992.81 0 0 1 1-63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f8f8",
    d: "M27.5 52.5h3v62h-3v-62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#686868",
    d: "M43.5 52.5v62h3c-1.068.934-2.401 1.268-4 1a992.81 992.81 0 0 1 1-63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M43.5 52.5h3v62h-3v-62zM62.5 52.5v62h-3v-62h3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "gray",
    d: "M62.5 52.5a992.81 992.81 0 0 1 1 63c-1.599.268-2.932-.066-4-1h3v-62z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteButtonMin);
export default __webpack_public_path__ + "static/media/delete-button-min.fff19ad7fc8d1e4cc9e73c0fddbf6179.svg";
export { ForwardRef as ReactComponent };